
import { Box } from '@mui/material';
import Heading from '../text/Heading';
import Subheading from '../text/Subheading';
import { ReactComponent as TableError } from '../../../styles/svg/tableerror.svg'
import { useTranslation } from 'react-i18next';
import Text from '../text/Text';

const SearchError = () => {
    const {t} = useTranslation();
    
    return (
        <Box 
            sx={{
                display:"flex",
                justifyContent:"center",
            }}
        >
            <Box
                sx={{
                    maxWidth:360,
                    display:"flex",
                    justifyContent:"center",
                    flexDirection:"column",
                    alignItems:"center"
                }}
            >
                <TableError/>
                <Box
                    sx={{
                        mt:3,
                        display:"flex",
                        flexDirection:"column",
                        gap:0.5
                    }}
                >
                    <Subheading textAlign="center">{t('grid_error_title')}</Subheading>
                    <Text align="center" light>{t('grid_error_description')}</Text>
                </Box>
            </Box>
        </Box>
    );
}

export default SearchError;